import Vue from 'vue';
import Vuex from 'vuex';
import frfwScan from './frfw/scan';
import frfwCert from './frfw/cert';
import createPersistedState from 'vuex-persistedstate';
import Storage from 'vue-ls';

Vue.use(Storage, {
  namespace: 'sheca_zstg_', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'session', // storage name session, local, memory
});
Vue.use(Vuex);

export default new Vuex.Store({
  modules: { frfwScan, frfwCert },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => Vue.ls.get(key),
        setItem: (key, value) => {
          Vue.ls.set(key, value, 60 * 60 * 1000);
        }, // 1h
        removeItem: (key) => Vue.ls.remove(key),
      },
    }),
  ],
});
